import { render, staticRenderFns } from "./Confeccion.vue?vue&type=template&id=6624818e&"
import script from "./Confeccion.vue?vue&type=script&lang=js&"
export * from "./Confeccion.vue?vue&type=script&lang=js&"
import style0 from "./Confeccion.vue?vue&type=style&index=0&id=6624818e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports